import SVTAPI from './svtapi';

class Items extends SVTAPI {
  constructor() {
    super('/items');
  }

  /**
   * GET /items
   * Gets a list of items.
   *
   * @param   {Object} filters Filter results e.g. by client
   * @returns {Object}         The server's response
   */
  get(filters) {
    return super.get({ data: filters });
  }

  getList(filters) {
    return super.get({ url: '/list/', data: filters });
  }

  /**
   * POST /items
   * Creates a new item manually.
   *
   * @param   {Object} data The data of the newly created item
   * @returns {Object}      The server's response
   */
  post(data) {
    return super.post({ data });
  }

  /**
   * GET /items/search
   * Retrieves a list of items matching the given search term
   *
   * @param {Object} data - The search term
   * @returns {Object} - The server's response
   */
  search(data) {
    const { term } = data;
    return super.get({ url: `/search/${ encodeURIComponent(term) }` });
  }
}

export default new Items();
